import behaviors from './behaviors'
import createSearch from '../createSearch'
// import DropDownComponent from './BinSearch'

const RepairSerialNumberSearch = createSearch({
  name: 'RepairSerialNumberSearch',
  behaviors,
  popoverStyle: { width: 500 },
  // DropDownComponent,
  meta: {
    allowInstantSearch: true,
    allowSearchAll: true,
    minimumKeywordLength: 1,
    allowNavigation: false,
    allowSpecialProducts: false,
    hasFilters: false,
    hideToggle: true
  }
})

export default RepairSerialNumberSearch
